import { render, staticRenderFns } from "./declare.vue?vue&type=template&id=f176cdde&scoped=true"
import script from "./declare.vue?vue&type=script&lang=js"
export * from "./declare.vue?vue&type=script&lang=js"
import style0 from "./declare.vue?vue&type=style&index=0&id=f176cdde&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f176cdde",
  null
  
)

export default component.exports